import { ConditionEnum } from '@/generated/graphql';

export const conditionLabel = (label: string): string => {
  if (label === ConditionEnum.New) return 'background-color: #25d0bb';
  if (label === ConditionEnum.Refurbished) return 'background-color: #3e7ce0';
  return 'background-color: #ffc107';
};

export default {};
